import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import * as React from 'react';
import { observer, inject } from 'mobx-react';
import translate from '../translate';
import { StoreName } from '../../../shared/stores/StoreName';
/**
 * Editable translate field component
 */

var Translate =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Translate, _React$Component);

  function Translate(props) {
    var _this;

    _classCallCheck(this, Translate);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Translate).call(this, props));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }
  /**
   * Renders either span with translation or key depending on showKeys state
   * Renders editable input in editMode state
   */


  _createClass(Translate, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var params = this.props.params || [];
      var translation = translate.apply(void 0, [this.props.id].concat(_toConsumableArray(params)));

      if (translation === this.props.id && this.props.default) {
        translation = this.props.default;
      }

      if (this.props.dictionaryStore.editMode) {
        return React.createElement("input", {
          type: "text",
          key: "edited",
          className: "translated editable",
          onBlur: this.handleBlur,
          onKeyUp: this.handleKeyUp,
          ref: function ref(input) {
            return _this2.input = input;
          },
          "data-key": this.props.id,
          defaultValue: translation,
          placeholder: this.props.id,
          onClick: function onClick(e) {
            return e.preventDefault();
          }
        });
      }

      return typeof translation === 'object' ? translation : React.createElement("span", {
        key: "static",
        className: "translated",
        "data-i18n-key": this.props.id,
        onClick: function onClick(e) {
          if (_this2.props.disabled) {
            e.preventDefault();
            e.nativeEvent.stopImmediatePropagation(); // Prevent click bubbling

            e.stopPropagation();
          }
        }
      }, translation);
    }
    /**
     * Stores current input value to ref
     * @param ev Event object
     */

  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(ev) {
      this.input = ev.target;

      if (ev.which === 13) {
        ev.target.blur();
      }
    }
    /**
     * Updates translation in localStorage on blur
     */

  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.props.dictionaryStore.updateLocalization(this.props.dictionaryStore.language, this.props.id, this.input.value);
    }
  }]);

  return Translate;
}(React.Component);

Translate = __decorate([inject(function (allStores) {
  return {
    dictionaryStore: allStores[StoreName.Dictionary]
  };
}), observer, __metadata("design:paramtypes", [Object])], Translate);
export default Translate;